export const CONCEPTO_LABEL: Record<string, string> = {
    compras:                            'Compra',
    inventario_inicial:                 'Inventario Inicial',
    por_ajuste_de_inventario_entrada:   'Ajuste Entrada',
    por_promocion_de_proveedor_entrada: 'Promo Proveedor',
    ventas:                             'Venta',
    por_ajuste_de_inventario_salida:    'Ajuste Salida',
    por_averia_de_producto_salida:      'Avería',
    por_consumo_salida:                 'Consumo',
    regularizacion:                     'Regularización',
};

// Descripción completa de los ajustes: tipo de ajuste + motivo seleccionado al registrarlo
// (mismos motivos que KardexEditarEntradaSalidaComponent).
export const CONCEPTO_DESCRIPCION: Record<string, string> = {
    por_ajuste_de_inventario_entrada:   'Ajuste Entrada - Por Ajuste de Inventario',
    por_promocion_de_proveedor_entrada: 'Ajuste Entrada - Por Promoción de Proveedor',
    por_ajuste_de_inventario_salida:    'Ajuste Salida - Por Ajuste de Inventario',
    por_averia_de_producto_salida:      'Ajuste Salida - Por Avería de Producto',
    por_consumo_salida:                 'Ajuste Salida - Por Consumo',
};

export const labelConcepto = (concepto: string) => CONCEPTO_LABEL[concepto] ?? concepto;

export const descripcionConcepto = (concepto: string) => CONCEPTO_DESCRIPCION[concepto] ?? labelConcepto(concepto);
